// extracted by mini-css-extract-plugin
export default {"title":"CardTitle_title__gbM3b"};